import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {TransferHttpCacheModule} from '@nguniversal/common';
import {RouterModule, Routes} from '@angular/router';
import {CoreModule} from 'src/app/core/core.module';
import {LoadingBarRouterModule} from '@ngx-loading-bar/router';
import fa from '@angular/common/locales/fa';
import {LocationStrategy, registerLocaleData} from "@angular/common";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {BaseHrefPathLocationStrategy} from "./history.replace-state";
import { MatDialogModule } from '@angular/material/dialog';
import {LayoutModule} from '@angular/cdk/layout';


registerLocaleData(fa);


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./feature/feature.module').then(m => m.FeatureModule)
  }
]

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    BrowserAnimationsModule,
    TransferHttpCacheModule,
    HttpClientModule,
    CoreModule,
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      scrollPositionRestoration: 'enabled'
    }),
    LoadingBarRouterModule,
    MatDialogModule,
    LayoutModule
  ],
  bootstrap: [AppComponent],
  providers: [{
    provide: LocationStrategy,
    useClass: BaseHrefPathLocationStrategy,
  }]
})
export class AppModule {
}
